module.exports = __webpack_public_path__ + "img/close-dark.4a7f2a85.svg";